import { regex } from './common'
export default regex('businessName', /^[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ |{},.:;?¿¡!"()@\-_Ð><»«*#%&$+\d\s\][]{2,100}$/)
